(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  var mq = window.matchMedia("(max-width: 767px)");
  var swiper = null;

  // Swiper is loaded via a static CDN <script> tag in the section markup.
  // This only waits until that global is ready (handles the defer/async race).
  function whenSwiperReady(cb) {
    if (typeof Swiper !== "undefined") { cb(); return; }

    var tag = document.querySelector('script[src*="swiper-bundle.min.js"]');
    if (tag) {
      tag.addEventListener("load", function () {
        if (typeof Swiper !== "undefined") { cb(); }
      });
    }

    // Fallback poll in case the load event already fired before we attached.
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== "undefined") { clearInterval(timer); cb(); }
      else if (++tries > 100) { clearInterval(timer); } // ~10s give up
    }, 100);
  }

  // Wrap grid + children into Swiper markup (mobile only)
  function buildDom(section) {
    var grid = section.querySelector(".product-grid");
    if (!grid) { return null; }
    if (grid.dataset.swiperReady) {
      return section.querySelector(".related-products-swiper");
    }

    var children = Array.prototype.slice.call(grid.children);
    children.forEach(function (child) {
      var slide = document.createElement("div");
      slide.className = "swiper-slide";
      grid.insertBefore(slide, child);
      slide.appendChild(child);
    });

    grid.classList.add("swiper-wrapper");

    var sw = document.createElement("div");
    sw.className = "swiper related-products-swiper";
    grid.parentNode.insertBefore(sw, grid);
    sw.appendChild(grid);

    grid.dataset.swiperReady = "1";
    return sw;
  }

  // Restore original DOM exactly (desktop)
  function teardown(section) {
    if (swiper) { swiper.destroy(true, true); swiper = null; }

    var sw = section.querySelector(".related-products-swiper");
    if (!sw) { return; }

    var grid = sw.querySelector(".product-grid");
    var slides = Array.prototype.slice.call(grid.children).filter(function (n) {
      return n.classList && n.classList.contains("swiper-slide");
    });

    slides.forEach(function (slide) {
      while (slide.firstChild) {
        grid.insertBefore(slide.firstChild, slide);
      }
      grid.removeChild(slide);
    });

    grid.classList.remove("swiper-wrapper");
    delete grid.dataset.swiperReady;

    sw.parentNode.insertBefore(grid, sw);
    sw.parentNode.removeChild(sw);
  }

  function apply(section) {
    if (!section) { return; }

    if (mq.matches) {
      whenSwiperReady(function () {
        if (!mq.matches) { return; } // breakpoint changed while waiting
        var el = buildDom(section);
        if (el && !el.swiper) {
          swiper = new Swiper(el, {
            slidesPerView: 1.2,
            spaceBetween: 0,
            grabCursor: true,
            watchOverflow: true
          });
        }
      });
    } else {
      teardown(section);
    }
  }

  function getSection() {
    return document.querySelector(".related-products");
  }

  function loadProductRecommendationsIntoSection() {
    var section = getSection();
    if (section === null) { return; }

    var request = new XMLHttpRequest();
    request.open("GET", section.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var fresh = container.querySelector(".related-products");
        if (fresh) {
          section.innerHTML = fresh.innerHTML;
          apply(section); // init AFTER content injected
        }
      }
    };
    request.send();
  }

  // Re-fetch when section reloads in theme editor
  document.addEventListener("shopify:section:load", function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });

  // React to viewport crossing the breakpoint
  if (mq.addEventListener) {
    mq.addEventListener("change", function () { apply(getSection()); });
  } else if (mq.addListener) {
    mq.addListener(function () { apply(getSection()); });
  }

  loadProductRecommendationsIntoSection();
})();

  } catch(e) { console.error(e); }
})();
})();
